import { Injectable } from "@angular/core";
import {
	Http,
	Headers,
	RequestOptions,
	Response
} from "@angular/http";
import {
	Router,
	ActivatedRoute
} from "@angular/router";
import { Observable } from "rxjs/Rx";
import "rxjs/add/operator/toPromise";

import {
	textFormat
} from "../functions";
import {
	MESSAGE_DIALOG_TYPE,
	MESSAGE_DIALOG_RETURN_TYPE
} from "../common.constant";
import { CtmMessageService } from "./message.service";
import { CtmTranslateService } from "./translate.service";
import { CtmApiLoader } from "./api.loader.service";

import {
	CONSTANT
} from "../../_custom";

@Injectable()
export class ApiService {
	constructor(
		private http: Http,
		private router: Router,
		private message: CtmMessageService,
		private translate: CtmTranslateService,
		private apiLoader: CtmApiLoader
	) {
	}

	public callApiController(url: string, option: any = null): Promise<Object> {
		let headers = new Headers({
			"Content-Type": "application/json; charset=UTF-8"
		});
		let options = new RequestOptions({
			"headers": headers
		});

		let showLoading = true;
		let type = "GET";
		let data = {};
		let showError = true;
		if (option != undefined) {
			if (option.type != undefined) {
				type = option.type;
			}
			if (option.showLoading != undefined) {
				showLoading = option.showLoading;
			}
			if (option.data != undefined) {
				data = option.data;
			}
			if (option.showError != undefined) {
				showError = option.showError;
			}
		}

		if (showLoading) {
			this.apiLoader.show();
		}
		if (type == "POST") {
			let _data = JSON.stringify(data);

			return this.http.post(CONSTANT.SERVER_PATH + url, _data, options)
				.toPromise()
				.then((res: Response) => {
					let r = this.extractData(res);
					if (r instanceof Promise) {
						return r.then((data) => {
							if (showLoading) {
								this.apiLoader.hide(500);
							}
							return data;
						})
							.catch(() => {
								if (showLoading) {
									this.apiLoader.hide(500);
								}

								return null;
							});
					}
					else {
						if (showLoading) {
							this.apiLoader.hide(500);
						}
						return r;
					}
				})
				.catch((error: Response) => {
					if (showError) {
						let r = this.handleError(error);
						if (r instanceof Promise) {
							return r.then((data) => {
								if (showLoading) {
									this.apiLoader.hide(500);
								}
								return data;
							})
								.catch(() => {
									if (showLoading) {
										this.apiLoader.hide(500);
									}

									return null;
								});
						}
						else {
							if (showLoading) {
								this.apiLoader.hide(500);
							}
							return r;
						}
					}
					else {
						if (showLoading) {
							this.apiLoader.hide(500);
						}
						return error;
					}
				});
		}
		else {
			return this.http.get(CONSTANT.SERVER_PATH + url, options)
				.toPromise()
				.then((res: Response) => {
					let r = this.extractData(res);
					if (r instanceof Promise) {
						return r.then((data) => {
							if (showLoading) {
								this.apiLoader.hide(500);
							}
							return data;
						})
							.catch(() => {
								if (showLoading) {
									this.apiLoader.hide(500);
								}

								return null;
							});
					}
					else {
						if (showLoading) {
							this.apiLoader.hide(500);
						}
						return r;
					}
				})
				.catch((error: Response) => {
					if (showError) {
						let r = this.handleError(error);
						if (r instanceof Promise) {
							return r.then((data) => {
								if (showLoading) {
									this.apiLoader.hide(500);
								}
								return data;
							})
								.catch(() => {
									if (showLoading) {
										this.apiLoader.hide(500);
									}

									return null;
								});
						}
						else {
							if (showLoading) {
								this.apiLoader.hide(500);
							}
							return r;
						}
					}
					else {
						if (showLoading) {
							this.apiLoader.hide(500);
						}
						return error;
					}
				});
		}
	}
	public downloadFile(url: string, option: any): Promise<Object> {
		return this.callApiController(url, option)
			.then(
			(result) => {
				if (result != undefined) {
					// var wind = window.open(CONSTANT.SERVER_PATH + "api/Common/Download?f=" + result, "_blank");
					// if (wind != undefined) {
					// 	wind.focus();
					// }

					var link = document.createElement("a");
					// Browsers that support HTML5 download attribute
					if (link.download !== undefined)  {
						link.setAttribute("href", CONSTANT.SERVER_PATH + "api/Common/Download?f=" + result);
						link.setAttribute("download", result as string);
						link.style.visibility = "hidden";
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
					}

					return true;
				}

				return false;
			}
			);
	}
	public uploadFile(url: string, option: any = null): Promise<Object> {
		let headers = new Headers({
		});
		let options = new RequestOptions({
			"headers": headers
		});

		let fd = new FormData();

		let showLoading = true;
		let showError = true;
		if (option != undefined) {
			if (option.showLoading != undefined) {
				showLoading = option.showLoading;
			}
			if (option.files != undefined) {
				option.files.forEach((f,i) => {
					fd.append(`file_${i}`, f);
				});
			}
			if (option.data != undefined) {
				fd.append("parameter", JSON.stringify(option.data));
			}
			if (option.showError != undefined) {
				showError = option.showError;
			}
		}

		if (showLoading) {
			this.apiLoader.show();
		}

		return this.http.post(CONSTANT.SERVER_PATH + url, fd, options)
				.toPromise()
				.then((res: Response) => {
					let r = this.extractData(res);
					if (r instanceof Promise) {
						return r.then((data) => {
							if (showLoading) {
								this.apiLoader.hide(500);
							}
							return data;
						})
							.catch(() => {
								if (showLoading) {
									this.apiLoader.hide(500);
								}

								return null;
							});
					}
					else {
						if (showLoading) {
							this.apiLoader.hide(500);
						}
						return r;
					}
				})
				.catch((error: Response) => {
					if (showError) {
						let r = this.handleError(error);
						if (r instanceof Promise) {
							return r.then((data) => {
								if (showLoading) {
									this.apiLoader.hide(500);
								}
								return data;
							})
								.catch(() => {
									if (showLoading) {
										this.apiLoader.hide(500);
									}

									return null;
								});
						}
						else {
							if (showLoading) {
								this.apiLoader.hide(500);
							}
							return r;
						}
					}
					else {
						if (showLoading) {
							this.apiLoader.hide(500);
						}
						return error;
					}
				});
	}


	private extractData(res: Response) {
		let body = res.json();
		if (body != undefined) {
			if (body.HasError == true) {
				return new Promise((resolve, reject) => {
					this.showErrorMessage(body, 0, resolve, reject);
				}).then((res) => {
					return res;
				}).catch((e) => {
					return null;
				})
			}
			else if (body.Data != undefined) {
				return body.Data;
			}
		}

		return null;
	}
	private showErrorMessage(body, idx, resolve, reject) {
		if (body.Messages != undefined) {
			if (idx < body.Messages.length) {
				var msg = body.Messages[idx];

				let show = false;
				if (this.apiLoader.isShow() == true) {
					this.apiLoader.hide();
					show = true;
				}
				this.message.openMessageDialog(
					textFormat(this.translate.instant(msg.MessageCode, "MESSAGE"), msg.Parameters),
					msg.MessageType)
					.then((type: MESSAGE_DIALOG_RETURN_TYPE) => {
						if (show) {
							this.apiLoader.show();
						}

						if (msg.MessageType == MESSAGE_DIALOG_TYPE.QUESTION
							|| msg.MessageType == MESSAGE_DIALOG_TYPE.WARNING_QUESTION
							|| msg.MessageType == MESSAGE_DIALOG_TYPE.QUESTION_WITH_CANCEL 
							|| msg.MessageType == MESSAGE_DIALOG_TYPE.QUESTION_OK) {

							if (type == MESSAGE_DIALOG_RETURN_TYPE.OK
								|| type == MESSAGE_DIALOG_RETURN_TYPE.YES) {
								this.showErrorMessage(body, idx + 1, resolve, reject);
							}
							else {
								reject();
							}
						}
						else {
							this.showErrorMessage(body, idx + 1, resolve, reject);
						}
					});
			}
			else {
				resolve(body.Data ? body.Data : null);
			}
		}
		else {
			resolve(body.Data ? body.Data : null);
		}
	}


	private handleError(error: Response) {
		// In a real world app, we might use a remote logging infrastructure
		if (error instanceof Response) {
			if (error.status == 0) {
				this.router.navigate(["/503"]);
			}
			else if (error.status == 401
				|| error.status == 404) {
				this.message.openMessageDialog(
					this.translate.instant("CLE008", "MESSAGE"))
					.then(() => {
						this.router.navigate(["/login"]);
					});
			}
		}

		return Promise.reject(error);
	}
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/_common/services/api.service.ts